var lib_core = require("lib-core");

var GlueData = function (shape, onTopLayer) {
    var self = this;

    this.makeObservableTreeNode();

    this.shape = this.value("shape", true);

    this.onTopLayer = this.value("onTopLayer", true);

    if(shape != undefined) this.shape(shape);
    if(onTopLayer != undefined) this.onTopLayer(onTopLayer);

    var addShapeShadows = function () {
        if(self.shape()) {
            self.geometry = self.shape().geometry;
            self.segmentedGeometry = self.shape().segmentedGeometry;
            self.boundingBox = self.shape().boundingBox;
        }
    };

    if(this.shape()) addShapeShadows();
    this.shape.onChange("shapeChanged", addShapeShadows);
};
lib_core.mixin(GlueData, lib_core.ObservableTreeNode);

lib_core.JsonParser.registerClass(GlueData, "Glue");

module.exports = GlueData;

GlueData.prototype.move = function (vec) {
    return this.shape() && this.shape().move(vec);
};

GlueData.prototype.rotate = function (angle) {
    return this.shape() && this.shape().rotate(angle);
};

GlueData.prototype.flip = function (flipline) {
    return this.shape() && this.shape().flip(flipline);
};

